import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useDeletePostMutation = createMutationHook(MembershipsCreatorApiClient.deletePost, {
  mutationKey: ['deletePost'],
})
